import {DateTime, Duration} from "luxon";

export enum Type {ANY, AUDIO, DOCUMENT, IMAGE, VIDEO}

type Temporal = {
    duration: Duration
}

type Dimensions = {
    height: number
    width: number
}

export type MediaId = number

export type MediaFile = {
    id: MediaId
    name: string
    file_name: string
    size: number
    mime_type: string
    type?: string
    original_url: string
    preview_url?: string
    created_at: DateTime
    updated_at: DateTime
}

export type AudioFile = MediaFile & Temporal & {type: 'audio'}
export type ImageFile = MediaFile & Dimensions & {type: 'image'}
export type VideoFile = MediaFile & Dimensions & Temporal & {type: 'video'}
export type DocumentFile = MediaFile & {type: 'document'}

export type AnyMedia = AudioFile | ImageFile | VideoFile | DocumentFile

export type MediaIdentifier = {
    id: MediaId
}